export default class MenuItem {

    constructor(el) {
        return;
        this.el = el;
        this.setEvents();
    }

    static get selector() {
        return '.header__menuItem--haveChild';
    }

    setEvents() {
        this.el.addEventListener('click',(e) => {this.e_click(e)}, false);
    }
    
    /**
     * Events
     */

    e_click(e) {
        e.preventDefault();
    }
}